import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react"; // или замени на свои иконки стрелок
import { useAppContext } from "../context/AppContext";
import { LandingTrans } from "../utils/translations";

const ReviewsSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { language } = useAppContext();

    const prevReview = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? reviews[language].length - 1 : prev - 1
        );
    };


    const nextReview = () => {
        setCurrentIndex((prev) =>
            prev === reviews[language].length - 1 ? 0 : prev + 1
        );
    };


    const reviews = {
        russian: [
            {
                id: 1,
                image: "/assets/images/reviewer3.jpg",
                text: "Огромное спасибо Ане Joy за её вдохновляющие занятия! Это не просто уроки йоги, а настоящее путешествие к гармонии тела и духа. Каждое занятие проводится с вниманием к деталям, заботой о каждом участнике и с удивительной теплой и располагающей энергетикой. Анюта умеет создать уютную и безопасную атмосферу, где хочется раскрывать свои возможности и становиться лучше. Она всегда предлагает варианты для любого уровня подготовки, что позволяет каждому почувствовать уверенность в своих силах. После её практик я чувствую лёгкость, спокойствие и заряд энергии. Это бесценный опыт, который я с радостью рекомендую всем!",
                name: "Даша",
            },
            {
                id: 7,
                image: "",
                text: "Anya Joy обалденный преподаватель! Хожу только первый месяц, но вижу результаты. Как тело меняется на глазах, и подтягивает за собой мышление. Распаковываются давно забытые вещи, откуда-то появляется энергия продолжать начинания, которые казались фантазиями еще пару месяцев назад! Короче, не рекомендую тем, кто не хочет совершать прорыв в своей жизни 😜🥳🤩",
                name: "Анна"
            },
            {
                id: 4,
                image: "/assets/images/reviewer2.jpg",
                text: "Благодорю за вчерашнюю практику🙏 Хорошо попрактиковали,ушла от вас наполненная энергией и в то же время с тишиной в уме. Тот случай,когда все сложилось-атомосфера,люди,настрой и классный преподователь.☘️",
                name: "Анжела",
            },
            {
                id: 2,
                image: "/assets/images/reviewer3.jpg",
                text: "Как человек, занимающийся йогой более 2 лет и побывавший на практиках у нескольких разных инструкторов, могу однозначно рекомендовать инструктора Аню Джой. Практика с Аней всегда оставляет позитивное впечатление и дает заряд энергии, а также ощущение повышенного тонуса в теле в течение следующих 48 часов. Аня внимательна к ученикам, замечает и корректирует неправильное выполнение асан и техник. Динамика занятий имеет среднюю интенсивность, что делает их подходящими как для новичков, так и для более опытных практикующих",
                name: "Артём",
            },
            {
                id: 3,
                image: "/assets/images/reviewer1.jpg",
                text: "Мне очень нравились твои уроки по энергетике, с тобой приятно находиться в одном пространстве. То как ты даешь йогу, мне очень подходит. Может быть кому-то хочется послабее или посильнее, мне вот это в самый раз. Я люблю, чтобы не зависали люди в асанах, чтобы все было в достаточно хорошем темпе и нагрузка для меня кажется оптимальной. То есть это и challenging и по силам мне. Мне нравится, когда преподаватель обращает внимание, чуть подкорректирует, но не слишком сильно, чтобы я не чувствовала сверх критики в свой адрес, но и мягкая коррекция тоже необходима. Для меня было супер классно, что ты мне помогаешь запрышивать в стойку на руках, потому что хочется постоять, запрыгнуть, почувствовать, что я что-то могу.",
                name: "Екатерина",
            },

            {
                id: 5,
                image: "/assets/images/reviewer3.jpg",
                text: "Спасибо за сегодня! Я очень Рада что тебя нашла ))) было кайфово ! Не просто но кайфово !!!",
                name: "Варвара",
            },
            {
                id: 6,
                image: "/assets/images/reviewer3.jpg",
                text: "Мне выпал случай побывать у Ани на уроках Йоги. Всегда очень комфортно на ее уроках, ее спокойствие и уверенность передается всем участникам, поэтому всегда присутствует комфортная, спокойная энергетика на занятиях. Если вам это важно, то несомненно у Ани вам понравится! Так же мне понравилось плавное вхождение в более тяжелые позы и плавный с них выход, что делает окончание занятий очень естественным и приятным.",
                name: "Аня",
            },
        ],
        english: []
    };

    return (
        reviews[language].length ? <section className="relative bg-white py-14 px-6 w-full">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-12 text-center">💬 {LandingTrans[language].reviews}</h2>

            {/* Стрелка влево */}
            <button
                onClick={prevReview}
                className="absolute left-0 md:left-4 top-1/2 transform -translate-y-1/2 text-darkBrown hover:text-pink-600 transition"
            >
                <ChevronLeft size={40} />
            </button>

            {/* Стрелка вправо */}
            <button
                onClick={nextReview}
                className="absolute right-0 md:right-4 top-1/2 transform -translate-y-1/2 text-darkBrown hover:text-pink-600 transition"
            >
                <ChevronRight size={40} />
            </button>

            {/* Контент отзыва */}
            <div className="max-w-xl mx-auto flex flex-col items-center text-center">
                {/* Картинка */}
                {/* <img
                        src={reviews[currentIndex].image}
                        alt="Review"
                        className="w-32 h-32 object-cover rounded-full mb-8 shadow-lg"
                    /> */}

                {/* Текст */}
                <p className="text-lg leading-relaxed text-darkBrown mb-6 px-4">
                    {reviews[language][currentIndex].text}
                </p>

                {/* Имя автора */}
                <p className="text-base font-semibold text-darkBrown/80 mb-6">
                    — {reviews[language][currentIndex].name}
                </p>

                {/* Точки-индикаторы */}
                <div className="flex justify-center gap-3 mt-6">
                    {reviews[language].map((_, index) => (
                        <div
                            key={index}
                            className={`w-3 h-3 rounded-full ${index === currentIndex ? "bg-pink" : "bg-gray-300"
                                } transition`}
                        />
                    ))}
                </div>
            </div>
        </section> : ""
    );
};

export default ReviewsSection;
